import img_1 from './Assets/team-img1.png'
import img_2 from './Assets/team-img2.png'
export const teamMembers = [
    {
      name: 'Yuvaraj',
      position: 'Co-founder/CTO',
      imgSrc: img_2,
      githubUrl: 'https://github.com/',
      linkedinUrl: 'https://www.linkedin.com/',
      gmailUrl: 'https://www.google.com/'
    },
    {
      name: 'Mariyam',
      position: 'Lead HR officer',
      imgSrc: img_1,
      githubUrl: 'https://github.com/',
      linkedinUrl: 'https://www.linkedin.com/',
      gmailUrl: 'https://www.google.com/'
    },
    {
      name: 'Reshma',
      position: 'Business Development Lead',
      imgSrc: img_1,
      githubUrl: 'https://github.com/',
      linkedinUrl: 'https://www.linkedin.com/',
      gmailUrl: 'https://www.google.com/'
    },
    {
      name: 'Tanmaie Usha Shree',
      position: 'Chief Branding Executive',
      imgSrc: img_1,
      githubUrl: 'https://github.com/',
      linkedinUrl: 'https://www.linkedin.com/',
      gmailUrl: 'https://www.google.com/'
    },
    {
      name: 'Tharun Balaji R',
      position: 'Lead App Developer',
      imgSrc: img_1,
      githubUrl: 'https://github.com/',
      linkedinUrl: 'https://www.linkedin.com/',
      gmailUrl: 'https://www.google.com/'
    },
    {
      name: 'Aayisha Noora J',
      position: 'Chief UI/UX designer',
      imgSrc: img_1,
      githubUrl: 'https://github.com/',
      linkedinUrl: 'https://www.linkedin.com/',
      gmailUrl: 'https://www.google.com/'
    },
    {
      name: 'Arun Pranav A T',
      position: 'Automation lead',
      imgSrc: img_1,
      githubUrl: 'https://github.com/',
      linkedinUrl: 'https://www.linkedin.com/',
      gmailUrl: 'https://www.google.com/'
    },
    {
      name: 'Amrize JK',
      position: 'Sales Manager',
      imgSrc: img_1,
      githubUrl: 'https://github.com/',
      linkedinUrl: 'https://www.linkedin.com/',
      gmailUrl: 'https://www.google.com/'
    },
    {
      name: 'Subicson',
      position: 'Lead Generator',
      imgSrc: img_2,
      githubUrl: 'https://github.com/',
      linkedinUrl: 'https://www.linkedin.com/',
      gmailUrl: 'https://www.google.com/'
    },
    {
      name: 'Sivadharshini',
      position: 'Chief Content writer',
      imgSrc: img_1,
      githubUrl: 'https://github.com/',
      linkedinUrl: 'https://www.linkedin.com/',
      gmailUrl: 'https://www.google.com/'
    },
    {
      name: 'C S Shriram Jayanth',
      position: 'Chief Back end Developer',
      imgSrc: img_1,
      githubUrl: 'https://github.com/',
      linkedinUrl: 'https://www.linkedin.com/',
      gmailUrl: 'https://www.google.com/'
    },
    {
      name: 'Valan Tamil Dasan A',
      position: 'Full Satck Developer',
      imgSrc: img_1,
      githubUrl: 'https://github.com/',
      linkedinUrl: 'https://www.linkedin.com/',
      gmailUrl: 'https://www.google.com/'
    },{
      name: 'Shivanand S',
      position: 'Marketing Executive',
      imgSrc: img_2,
      githubUrl: 'https://github.com/',
      linkedinUrl: 'https://www.linkedin.com/',
      gmailUrl: 'https://www.google.com/'
    },
    {
      name: 'Pravin B',
      position: 'Business Management Executive',
      imgSrc: img_1,
      githubUrl: 'https://github.com/',
      linkedinUrl: 'https://www.linkedin.com/',
      gmailUrl: 'https://www.google.com/'
    },
    {
      name: 'Dhoni R',
      position: 'Sales Executive',
      imgSrc: img_1,
      githubUrl: 'https://github.com/',
      linkedinUrl: 'https://www.linkedin.com/',
      gmailUrl: 'https://www.google.com/'
    },
    {
      name: 'Vaishnavi',
      position: 'Front-end Developer',
      imgSrc: img_1,
      githubUrl: 'https://github.com/',
      linkedinUrl: 'https://www.linkedin.com/',
      gmailUrl: 'https://www.google.com/'
    },
    {
      name: 'Azhagar Aadithyan',
      position: 'Graphic Designer',
      imgSrc: img_1,
      githubUrl: 'https://github.com/',
      linkedinUrl: 'https://www.linkedin.com/',
      gmailUrl: 'https://www.google.com/'
    },
    {
      name: 'Rikshitha',
      position: 'Designing Executive',
      imgSrc: img_1,
      githubUrl: 'https://github.com/',
      linkedinUrl: 'https://www.linkedin.com/',
      gmailUrl: 'https://www.google.com/'
    },
    {
      name: 'Surya',
      position: 'Back-end Developer',
      imgSrc: img_1,
      githubUrl: 'https://github.com/',
      linkedinUrl: 'https://www.linkedin.com/',
      gmailUrl: 'https://www.google.com/'
    },
    {
      name: 'Sri Ram Kumar R',
      position: 'Back-end Developer',
      imgSrc: img_1,
      githubUrl: 'https://github.com/',
      linkedinUrl: 'https://www.linkedin.com/',
      gmailUrl: 'https://www.google.com/'
    },
    {
      name: 'Dharshini  G A',
      position: 'Front-end Developer',
      imgSrc: img_1,
      githubUrl: 'https://github.com/',
      linkedinUrl: 'https://www.linkedin.com/',
      gmailUrl: 'https://www.google.com/'
    },
    {
      name: 'Janisha G',
      position: 'Front end Developer',
      imgSrc: img_1,
      githubUrl: 'https://github.com/',
      linkedinUrl: 'https://www.linkedin.com/',
      gmailUrl: 'https://www.google.com/'
    },
    {
      name: 'Sree Sahaana N',
      position: 'Front end Developer',
      imgSrc: img_1,
      githubUrl: 'https://github.com/',
      linkedinUrl: 'https://www.linkedin.com/',
      gmailUrl: 'https://www.google.com/'
    },
    {
      name: 'Santhosh S',
      position: 'Front end Developer',
      imgSrc: img_1,
      githubUrl: 'https://github.com/',
      linkedinUrl: 'https://www.linkedin.com/',
      gmailUrl: 'https://www.google.com/'
    }
  ];

